<!-- icp 备案号 -->
<template>
  <div class="icp_box">
      <img src="../assets/icon/jgwab.png" alt="">
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
        <span>粤ICP备2021063418号</span>
      </a>
    </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data () {
    return {
    };
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
.icp_box {
  
  text-align: center;
  color: #999;
  font-size: 14px;
  img {
    width: 26px;
    position: relative;
    top: 6px;
  }
}
</style>
